<template>
    <h1>Oops, page not found</h1>
</template>
